// React
import PropTypes from "prop-types";

// @mui material components
import { Card, Fade, Grid, Icon, InputLabel, Modal, Tooltip } from "@mui/material";

// Custom UI components
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { useEffect, useRef, useState } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "90%", sm: "40%", xxl: "30%" },
  overflow: "visible",
};

export default function ModalBandejas({ open, handleClose, onConfirm, initial }) {
  const [cantidad, setCantidad] = useState();
  const inputRef = useRef(null);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        if (inputRef.current) {
          const input = inputRef.current.querySelector("input");
          input.focus();
        }
      }, 100);
    }
  }, [open]);

  useEffect(() => {
    if (initial) setCantidad(initial);
  }, [initial]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox>
            <SoftBox>
              <SoftBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
                pb={0}
              >
                <SoftBox>
                  <SoftTypography variant="h6">Seleccionar cantidad de bandejas</SoftTypography>
                </SoftBox>
                <SoftBox>
                  <Tooltip title="Cerrar" placement="top">
                    <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                      close
                    </Icon>
                  </Tooltip>
                </SoftBox>
              </SoftBox>
              <SoftBox px={3}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <InputLabel htmlFor="cantidad">
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Cantidad de bandejas
                      </SoftTypography>
                    </InputLabel>
                    <SoftInput
                      label="cantidad"
                      placeholder="Ingrese la cantidad de bandejas a prestar"
                      type="number"
                      ref={inputRef}
                      value={cantidad}
                      inputProps={{ min: 0 }}
                      name="cantidad"
                      error={cantidad && cantidad < 0}
                      onChange={(e) => setCantidad(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && cantidad && cantidad > 0) {
                          onConfirm(parseInt(cantidad));
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </SoftBox>
            </SoftBox>
            <SoftBox
              display={{
                xs: "flex-row",
                sm: "flex",
              }}
              justifyContent="end"
              alignItems="center"
              p={3}
            >
              <SoftBox>
                <SoftButton
                  color="uproGreen"
                  circular
                  disabled={!cantidad || cantidad < 0}
                  fullWidth={{
                    xs: true,
                    sm: false,
                  }}
                  onClick={() => {
                    onConfirm(parseInt(cantidad));
                  }}
                >
                  <Icon sx={{ fontWeight: "light" }}>save</Icon>
                  &nbsp; Guardar
                </SoftButton>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalBandejas.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  onConfirm: PropTypes.func,
  initial: PropTypes.number,
};
